import Base from '@/plugins/Base';
import router from '@/plugins/Router'

const module = {
    namespaced: true,
    state: () => ({
        data: {},
        passportNumber: null,
        pin: null
    }),
    getters: {
        getData(state) {
            return state.data
        },
        getStatus(state){
            return state.data && state.data.status ? state.data.status:null;
        },
        getPassportNumber(state) {
            return state.passportNumber
        },
        getPin(state) {
            return state.pin
        }
    },

    mutations: {
        setData(state, data) {
            state.data = data
            Base.LocalStorage.set('exchange_student_app_data', state.data)
        },
        setStatus(state, status) {
            state.data.status = status;
            Base.LocalStorage.set('exchange_student_status_data', state.data)
        },
        setPassportNumber(state, passportNumber) {
            state.passportNumber = passportNumber
            Base.LocalStorage.set('exchange_student_app_id', state.passportNumber)
        },
        setPin(state, pin) {
            state.pin = pin
            Base.LocalStorage.set('exchange_student_app_pin', state.pin)
        },
        clearData(state) {
            state.data = {}
            state.passportNumber = null
            state.pin = null
        }
    },

    actions: {
        initData({commit}) {
            let data = Base.LocalStorage.get('exchange_student_app_data')
            let passportNumber = Base.LocalStorage.get('exchange_student_app_id')
            let pin = Base.LocalStorage.get('exchange_student_app_pin')
            if (data && passportNumber && pin) {
                commit('setData', data)
                commit('setPassportNumber', passportNumber)
                commit('setPin', pin)
            }
        },

        isLogin({state}) {

            let data = state.data;
            let passportNumber = state.passportNumber;
            let pin = state.pin;
            if (!data || !passportNumber || !pin) {
                router.push('/exchangestudent/application/login')
            }
        },

        isLoginGoIndex({state}) {
            let data = state.data;
            let passportNumber = state.passportNumber;
            let pin = state.pin;
            if (data && passportNumber && pin) {
                router.push('/exchangestudent/application/form')
            }
        },

        logout({commit}) {
            commit('clearData')
            Base.LocalStorage.remove('exchange_student_app_data')
            Base.LocalStorage.remove('exchange_student_app_id')
            Base.LocalStorage.remove('exchange_student_app_pin')

            router.push('/exchangestudent/application/login')
        }
    }
}

export default module;
